/* eslint-disable import/no-named-as-default-member */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import firebase from '../../config/firebase'

import Loading from '../../components/common/loading'
import LoginContainer from '../login'

import AuthActions from '../../reducers/authReducer'

class RequireAuthenticate extends Component {
  constructor() {
    super()

    this.subscribeRole = null
  }

  componentDidMount() {
    const { setAuthenticated, setAuthData, handleAuthSuccess } = this.props

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        handleAuthSuccess(user.uid)
      } else {
        setAuthenticated(false)
        setAuthData({})
      }
    })
  }

  render() {
    const { loading, authenticated, children } = this.props

    if (loading) {
      return <Loading active />
    }
    if (authenticated) {
      return children
    }

    return (
      <div style={{ paddingTop: 100 }}>
        <LoginContainer />
      </div>
    )
  }
}

const mapState = ({ auth }) => ({
  auth: auth.data,
  authenticated: auth.authenticated,
  loading: auth.loading,
})

const mapDispatch = {
  handleAuthSuccess: AuthActions.handleAuthSuccess,
  setAuthData: AuthActions.setAuthData,
  setAuthenticated: AuthActions.setAuthenticated,
}

export default connect(mapState, mapDispatch)(RequireAuthenticate)



// WEBPACK FOOTER //
// ./src/containers/requireAuthenticate/index.js